import { render } from "./mobile_fields.vue?vue&type=template&id=139036d3"
import script from "./mobile_fields.vue?vue&type=script&lang=js"
export * from "./mobile_fields.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/mobile_fields.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "139036d3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('139036d3', __exports__)) {
    api.reload('139036d3', __exports__)
  }
  
  module.hot.accept("./mobile_fields.vue?vue&type=template&id=139036d3", () => {
    api.rerender('139036d3', render)
  })

}


export default __exports__